import { Injectable } from '@angular/core';

import { TreeItem } from '@frontend/sports/item/feature';
import { SessionStoreService } from '@frontend/vanilla/core';
import { cloneDeep } from 'lodash-es';

export enum TreeSource {
    Top,
    All,
}

export interface TreeState {
    sport: number;
    top: boolean;
    all: boolean;
    children: (number | string)[];
}

@Injectable({ providedIn: 'root' })
export class CompetitionStoreService {
    private readonly key = 'competition-tree';
    private state?: TreeState;

    constructor(private store: SessionStoreService) {
        this.state = this.store.get<TreeState>(this.key) || undefined;
    }

    init(sport: number): void {
        if (this.state && this.state.sport === sport) {
            return;
        }

        this.state = this.getDefault(sport);
    }

    get(sport: number): TreeState {
        return this.state && this.state.sport === sport ? cloneDeep(this.state) : this.getDefault(sport);
    }

    toggle(source: TreeSource, item?: TreeItem): void {
        if (!this.state) {
            throw new Error('State is not initialized');
        }

        if (source === TreeSource.Top) {
            this.state.top = !this.state.top;
        } else {
            if (item) {
                const index = this.state.children.indexOf(item.id);

                if (index !== -1 && !item.expanded) {
                    this.state.children.splice(index, 1);
                } else if (index === -1 && item.expanded) {
                    this.state.children.push(item.id);
                }
            } else {
                this.state.all = !this.state.all;
            }
        }

        this.setStore();
    }

    private getDefault(sport: number): TreeState {
        return {
            sport,
            top: true,
            all: true,
            children: [],
        };
    }

    private setStore(): void {
        this.store.set(this.key, this.state);
    }
}
